import { Separator as BaseSeparator } from '@base-ui-components/react/separator';
import { cn } from '../cn.js';

/**
 * A rule between groups.
 *
 * Base UI gives it the right role: a decorative separator is hidden from assistive technology and
 * an `orientation` is announced where it means something. A `<div>` with a border is neither.
 */
export function Separator({
  className,
  orientation = 'horizontal',
  ...props
}: BaseSeparator.Props) {
  return (
    <BaseSeparator
      orientation={orientation}
      className={cn(
        'shrink-0 bg-(--color-border)',
        orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
        className,
      )}
      {...props}
    />
  );
}
